import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingMenuRoot = styled("section")<{}>(() => {
  return css`
    // background-color: var(--bg-color);
    color: #000000;
    min-height: 335px;
    padding: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: -1px;
    @media ${responsiveMap.mobile} {
      padding: 24px 16px;
    }

    .landing-menu {
      &__container {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &__menu {
        text-align: center;
        position: relative;

        &__title {
          margin-bottom: 12px;
          text-align: center;

          @media ${responsiveMap.mobile} {
            margin-bottom: 9px;
          }
        }

        &__text {
          margin-bottom: 40px;
        }

        &__compact-link {
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          cursor: pointer;
          color: inherit;
          text-decoration: underline;
          text-underline-offset: 2px;
        }
      }
    }

    &.landing-menu--compact {
      min-height: auto;
      padding: 24px 16px;
    }
  `;
});
